export default __webpack_public_path__ + "static/media/bal.d473fa15.svg";